import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagKey } from './feature-flag-keys';
import { FeatureFlagsService, LDFlagValue } from './feature-flags.service';

/**
 * Pipe that returns the feature flag value as an Observable for use with the async pipe.
 * Use when you want to pass the key in the template without wiring getValue$() in the class.
 *
 * @example
 * // In template (expose FeatureFlagKey on the component):
 * @if ((FeatureFlagKey.ENABLEFAAPP | featureFlag | async) === true) { ... }
 * {{ FeatureFlagKey.ENABLEFAAPP | featureFlag | async }}
 *
 * // With custom default:
 * {{ flagKey | featureFlag:true | async }}
 */
@Pipe({
  name: 'featureFlag',
  standalone: true,
  pure: true,
})
export class FeatureFlagPipe implements PipeTransform {
  private readonly flags = inject(FeatureFlagsService);

  transform(
    flagKey: FeatureFlagKey | string,
    defaultValue: LDFlagValue = false
  ): Observable<LDFlagValue> {
    return this.flags.getValue$(flagKey, defaultValue);
  }
}
